import { useState } from "react";
import { Bl } from "../../../interfaces/bl-export/blexport.interface";
import {
  useDonwloadXlxsBlsMutation,
  useDownloadBlExportMutation,
  useDownloadCartaMutation,
} from "../../../services/bl-export/BLExportService";
import { donwloadDefaultFile } from "../helpers/downloadHelper";
import { UserInfo } from "../../../interfaces/auth/user.interface";

const useDownloadFiles = () => {
  const [isDownloadingXlsx, setIsDownloadingXlsx] = useState(false);

  const [downloadBLDocument] = useDownloadBlExportMutation();
  const [downloadXlsx] = useDonwloadXlxsBlsMutation();
  const [donwloadCarta] = useDownloadCartaMutation();

  const downloadFileOriginalOrCopy = async (
    bl: Bl,
    type: string,
    callback: () => void
  ) => {
    const res = await downloadBLDocument({
      fileName: type === "copy" ? bl.bl_file_copy! : bl.bl_file_original!,
      id_bl: Number(bl.id_bl!),
      type: type,
    });

    if ("data" in res && res.data instanceof Blob) {
      try {
        donwloadDefaultFile(
          type === "copy" ? bl.bl_file_copy! : bl.bl_file_original!,
          res.data,
          callback
        );
      } catch (error) {
        alert(String(error));
      }
    } else {
      alert("No se puede descargar el archivo en este momento.");
    }
  };

  const handleDownloadXlxs = async (
    userInfo: UserInfo,
    isHome: boolean | undefined,
    page: number,
    size: number,
    values: { type: string; value: string; filter_days: string },
    creadoApi: boolean,
    callback: () => void
  ) => {
    setIsDownloadingXlsx(true);
    const res = await downloadXlsx({
      id_usuario: userInfo?.perfil === "1" ? undefined : Number(userInfo?.id),
      page: isHome ? 0 : page,
      size: isHome ? 10 : size,
      filtro: values.type,
      valor: values.value.replace(/\s/g, ""),
      creadosHace: values.filter_days,
      creados_api: creadoApi ? creadoApi : undefined,
    });

    if ("data" in res && res.data instanceof Blob) {
      try {
        donwloadDefaultFile("bls.xlsx", res.data, callback);
      } catch (error) {
        alert(String(error));
      }
    } else {
      alert(String("No se pudo descargar el archivo. Intente luego"));
    }
    setIsDownloadingXlsx(false);
  };

  const handleDownloadCarta = async (bl: Bl, callback: () => void) => {
    const res = await donwloadCarta({
      fileName: bl.carta_gastos || "Null",
    });

    if ("data" in res && res.data instanceof Blob) {
      try {
        donwloadDefaultFile(bl.carta_gastos || "undefined", res.data, callback);
      } catch (error) {
        alert(String("No se pudo descargar el archivo. Intente luego"));
      }
    } else {
      alert(String("No se pudo descargar el archivo. Intente luego"));
    }
  };

  return {
    isDownloadingXlsx,
    downloadFileOriginalOrCopy,
    handleDownloadXlxs,
    handleDownloadCarta,
  };
};

export default useDownloadFiles;
